<div class="dialog-confirm">
  <div class="header">
      <label>CONTRASEÑA EXITOSA</label>
  </div>
  <div style="text-align: center">
    <div style="text-align: center; margin-top: 1.25rem">
      <svg-icon
      src="../../../../../assets/icons/ckeck-exito.svg"
      [svgStyle]="{
        'width.rem': 3.1875,
        'height.rem': 3.1875,
        position: 'relative',
        'top.rem': 0.15
      }"
      ></svg-icon>
    </div>
    <label class="label-message">Haz click en el botón para  ingresar al sistema.</label>

    <button (click)="onGoToProduct()"  style="margin-top: 0.3125rem" mat-flat-button>Ingresar</button>
  </div>

    <!-- <div mat-dialog-content>
      <svg-icon class="logout_timer" src="../../../assets/icons/wall-clock.svg"></svg-icon>
      <p class="modal-h1">
        <span class="lbl-msg">Tu sesión expirará en </span>
        <span class="lbl-seg">2 seg</span>
      </p>
    </div>
    <div mat-dialog-actions>
      <button mat-raised-button [mat-dialog-close]="true" cdkFocusInitial>
        <span id="refreshToken">Mantener activa</span>
      </button>
    </div> -->
  </div>

